import * as ng from 'angular';
import { ArchiSmallServices } from '../../../../services/archismall.service';

export class ArchidriveMoveController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        'ArchiSmallServices'
    ];

    private close: any;
    private dismiss: any;
    private mouvingItems: any;
    private currentLocation: any;

    constructor(
        private $scope: any,
        private $rootScope: any,
        private ArchiSmallServices: ArchiSmallServices
    ) {
        this.mouvingItems = $scope.$parent.$resolve.mouvingItems;
        this.currentLocation = $scope.$parent.$resolve.currentLocation;
        let getFolderRelativePath = (item) => {
            let folderRelativePath = item.parent + item.name + '/';
            folderRelativePath = folderRelativePath.substr(folderRelativePath.indexOf('/archidrive') + 11);
            return folderRelativePath;
        };
        let archiDriveRootPath = '';
        let getItems = (item) => {
            let relativePath = item.relativePath ? item.relativePath : '/';

            let filter = {
                'user': $rootScope.currentUser().sub,
                'fileName': '',
                //                        'estensione': '',
                'dataFrom': '',
                'dataTo': '',
                'directory': relativePath,
                'pageNumber': 1,
                'pageSize': 100
            };
            ArchiSmallServices.listArchidriveDirectory(filter)
                .then((response: any) => {
                    archiDriveRootPath = response.archiDriveRootPath;
                    if (response.directory !== undefined && archiDriveRootPath !== undefined) {
                        let items = [];
                        for (let i = 0; i < response.directory.length; i++) {
                            response.directory[i].relativePath = getFolderRelativePath(response.directory[i]);
                            response.directory[i].open = false;
                            response.directory[i].selected = false; // response.directory[i].isSelected
                            response.directory[i].disabled = $scope.itemIsDisabled(response.directory[i].relativePath);
                            items.push(response.directory[i]);
                        }
                        item.items = items;
                        item.loaded = true;
                    }
                }, (error) => {
                    $rootScope.alert('error', error);
                });
        };
        $scope.itemIsDisabled = (relativePath) => {
            // mouving items and current location are disabled
            for (let i = 0; i < this.mouvingItems.length; i++) {
                let folderRelativePath = getFolderRelativePath(this.mouvingItems[i]);
                if (this.mouvingItems[i].content_type === 'application/x-www-form-urlencoded;charset=UTF-8' && relativePath.indexOf(folderRelativePath) === 0) {
                    return true;
                }
            }
            if (archiDriveRootPath + this.currentLocation.substr(1) === relativePath) {
                return true;
            } else {
                return false;
            }
        };

        $scope.browseFolder = (item) => {
            item.open = !item.open;
            if (item.open && (!item.loaded)) {
                getItems(item);
            }
        };

        $scope.selectFolder = (item) => {
            if (item.disabled) {
                return;
            }
            if ($scope.relativePath === item.relativePath) {
                $scope.relativePath = '';
            } else {
                $scope.relativePath = item.relativePath;
            }
        };

        $scope.sposta = () => {
            if ($scope.relativePath !== '') {
                let toreturn = {
                    'relativePath': $scope.relativePath,
                    'archiDriveRootPath': archiDriveRootPath
                };
                this.close({ $value: toreturn });
            }
        };
        $scope.cancel = () => {
            this.dismiss();
        };
        $scope.archidrive = {
            'name': 'Archivia',
            'relativePath': '/',
            'open': true,
            'loaded': true,
            'items': [],
        };
        $scope.archidrive.disabled = this.currentLocation === $scope.archidrive.relativePath;
        $scope.relativePath = '';
        $scope.filescount = this.mouvingItems.length;
        getItems($scope.archidrive);
    }
}

export const ArchidriveMoveComponent: ng.IComponentOptions = {
    template: require('./archidrive-move.html'),
    controller: ArchidriveMoveController,
    bindings: {
        dismiss: '&',
        close: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/archidrive/archidrive-move/archidrive-move.ts